var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Row',[_c('Col',{attrs:{"span":"24"}},[_c('MyNotice',{style:({display: _vm.cloudshow?'block':'none'})}),_c('MyHistory',{style:({display: _vm.historyshow?'block':'none'})})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }